// Module
var code = "<div class=\"field-row {{containerClass}}\" data-test-id=\"{{containerClass}}\" data-propertyname=\"{{propertyName.toLowerCase()}}\"> <div class=\"head\"></div> <div class=\"body\"></div> </div> ";
// Exports
export default code;